<template>
  <yxt-sticky
    ref="sticky"
    auto-size
    resizable
    fixed
    keep-left
    style="height: 56px;"
  >
    <div class="gwnl-step-header">
      <div
        v-if="showBack"
        class="gwnl-step-header__back hand flex align-items-center"
        @click="$emit('back-click')"
      >
        <yxt-svg
          :remote-url="cdnMediaDomain + '/gwnl/pc/svg'"
          class="color-gray-10 vertical-align--middle"
          width="16px"
          height="16px"
          icon-class="page-header-back-arrow"
        />
        <span class="color-gray-10 ml8 font-medium">{{ this.$t('pc_gwnl_global_return') }}</span>
      </div>
      <div class="gwnl-step-header__center text-center">
        <slot name="center" />
      </div>
      <div class="gwnl-step-header__right">
        <slot name="right" />
      </div>
    </div>
  </yxt-sticky>
</template>
<script>
export default {
  name: 'TalentFixHeader',
  props: {
    // 是否展示返回按钮
    showBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cdnMediaDomain: `${this.$staticBaseUrl}ufd/c4d5f9`
    };
  }
};
</script>
<style lang='scss' scoped>
.gwnl-step-header {
  z-index: 99;
  height: 56px;
  line-height: 56px;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
  position: relative;
}

.gwnl-step-header__back {
  position: absolute;
  left: 24px;
}

.gwnl-step-header__center {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}

.gwnl-step-header__right {
  position: absolute;
  right: 24px;
}
</style>
